import { FormAtylBase } from '../../form-atyl-base'

export class AtylDatetime extends FormAtylBase<string> {
	controlType = 'date';
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
